import history from '@history';
import { AppInsightsAggregator } from '@lender/utils';

import { APPLICATIONINSIGHTS_CONNECTION_STRING } from 'constants/aiAggregator';

const isConnectionStringExist =
  APPLICATIONINSIGHTS_CONNECTION_STRING && APPLICATIONINSIGHTS_CONNECTION_STRING !== 'undefined';

export const aiAggregator = isConnectionStringExist
  ? new AppInsightsAggregator({
      disableTelemetry: process.env.DISABLE_AI_LOAD,
      history,
      tags: {
        'ai.cloud.role': 'Admin Panel',
      },
      connectionString: APPLICATIONINSIGHTS_CONNECTION_STRING,
      correlationHeaderExcludedDomains: [
        '*.queue.core.windows.net',
        '*.cubecloudapp.dev',
        '*.cke-cs.com',
        'docx-converter.cke-cs.com',
        'api.realestateapi.com',
      ],
      enableCorsCorrelation: true,
    })
  : undefined;
